import { Injectable } from '@angular/core';
import { SSCState } from '../../../reducers';
import { IdService } from '../id.service';

export const STATE_KEY = 'sscState';
export const SESSION_ID_KEY = 'session';

@Injectable({
  providedIn: 'root',
})
export class SessionService {
  constructor(private idService: IdService) {}

  public saveState(state: SSCState): void {
    SessionService.setItem(STATE_KEY, JSON.stringify(state));
  }

  public getState(): SSCState | undefined {
    const savedStateOnReload = sessionStorage.getItem(STATE_KEY);

    if (savedStateOnReload) {
      return JSON.parse(savedStateOnReload);
    }

    return undefined;
  }

  public saveSessionId(): void {
    if (!sessionStorage.getItem(SESSION_ID_KEY)) {
      SessionService.setItem(SESSION_ID_KEY, this.idService.generateRandomId());
    }
  }

  public getSessionId(): string | undefined {
    return sessionStorage.getItem(SESSION_ID_KEY) ?? undefined;
  }

  private static setItem(key: string, value: string): void {
    if (value) {
      sessionStorage.setItem(key, value);
    } else {
      sessionStorage.removeItem(key);
    }
  }
}
